import {
  useCompanyMenu,
  useImprintMenu,
  useKnowYourRightsMenu,
  useLegalMenu,
  useProductsMenu,
  useSupportMenu,
  useTopMenu,
} from "./useMenu";

export {
  useCompanyMenu,
  useImprintMenu,
  useKnowYourRightsMenu,
  useLegalMenu,
  useProductsMenu,
  useSupportMenu,
  useTopMenu,
};
